/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import { useEffect, useState } from "react";
import { normalize } from "utils/capitalize";
export const handleCustomNoteFilling = (note) => {
  if (note.includes("other:")) {
    // Vegan,Vegetarian,...,other:no sugar
    //                      ^ find index of the sentence
    const indexOfOther = note.indexOf("other:");
    const sentence = note.slice(indexOfOther);
    // other:no sugar
    const lengthToSlice = "other:".length;
    const customNote = sentence.slice(lengthToSlice);
    // no sugar
    return customNote;
  }
};

export const PREFERENCES_OPTIONS = [
  "vegetarian",
  "vegan",
  "pescatarian",
  "other",
];

const usePreferences = (companion) => {
  const [isPrefOther, setPrefOther] = useState(false);

  const PREFERENCES_OPTIONS = ["vegetarian", "vegan", "pescatarian", "other"];

  const [formData, setFormData] = useState(() =>
    PREFERENCES_OPTIONS.reduce((sum, key) => {
      return { ...sum, [key]: { state: "initial", value: key } };
    }, {})
  );
  const [customPref, setCustomPref] = useState("");
  useEffect(() => {
    if (!companion) return;
    const _preferences = companion?.food_preferences?.split(",");
    const customPref = handleCustomNoteFilling(companion?.food_preferences);
    if (customPref) {
      setPrefOther(true);
      setCustomPref(customPref);
    }
    _preferences?.forEach((pref) => {
      if (pref.startsWith("other:")) return;
      setFormData((prev) => {
        const safePref = normalize(pref);
        return { ...prev, [safePref]: { value: safePref, state: "success" } };
      });
    });
  }, [companion]);
  const handleOnChange = (text) => {
    setFormData((prev) => {
      if (prev[text].state === "success") {
        return { ...prev, [text]: { value: text, state: "initial" } };
      }
      return { ...prev, [text]: { value: text, state: "success" } };
    });
  };
  return {
    isPrefOther,
    setPrefOther,
    formData,
    setFormData,
    customPref,
    setCustomPref,
    handleOnChange,
  };
};

export default usePreferences;
